module.exports = __webpack_public_path__ + "images/3f5df9f9f7d3960dca007c39305de285d.svg";